<template>
	<div class="gallery">
		<swiper
			class="swipe"
			ref="swiper"
			:options="swiperOption"
			@slideChange="onSlideChange"
		>
			<swiper-slide
				v-for="(image, i) in images"
				:key="i"
				class="slide"
				id="element-near-top"
			>
				<img :src="image.url" />
			</swiper-slide>
		</swiper>
		<div class="pagination">
			<PaginationSlideshow
				:currentIndex="currentIndex + 1"
				:numberOfPosts="images.length"
				target="white"
				@onPaginationClick="onPaginationClick"
			></PaginationSlideshow>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.slide {
	text-align: center;
}
.pagination {
	margin-bottom: 50px;
}
img {
	max-width: 100%;
	width: 100%;
	margin-top: $spacing-0;
	height: 50vh;
	object-fit: contain;
	@media only screen and (max-width: 768px) {
		height: auto;
	}
}
.gallery {
	position: relative;
}

.pagination {
	position: relative;
	margin-top: 25px;
}
</style>

<script>
import PaginationSlideshow from "@/components/ui/PaginationSlideshow.vue";

export default {
	name: "core_gallery",
	props: ["block"],
	components: {
		PaginationSlideshow
	},
	mounted() {
		if(this.block.attributes.images.length) {
			this.images = this.block.attributes.images;
		}
		else if(this.block.innerBlocks) {
			this.images = this.block.innerBlocks.map((currentBlock) => {
				return {
					url: currentBlock.attributes.url
				};
			});
		}
	},
	data() {
		return {
			images: [],
			currentIndex: 0,
			swiperOption: {
				slidesPerView: 1,
				spaceBetween: 150,
				centeredSlides: true,
				activeColor: null,
				autoHeight: true
			}
		};
	},
	computed: {
		swiper() {
			return this.$refs.swiper.$swiper;
		}
	},
	methods: {
		onSlideChange() {
			this.currentIndex = this.swiper.activeIndex;
		},
		onPaginationClick(index) {
			this.swiper.slideTo(index);
		}
	}
};
</script>
